class Budget {
  public readonly startsOn?: Date;
  public readonly endsOn?: Date;
  public readonly obtainedPoint: number;
  public readonly availablePoint: number;
  constructor({
    startsOn,
    endsOn,
    obtainedPoint,
    availablePoint,
  }: {
    startsOn?: Date;
    endsOn?: Date;
    obtainedPoint: number;
    availablePoint: number;
  }) {
    this.startsOn = startsOn;
    this.endsOn = endsOn;
    this.obtainedPoint = obtainedPoint;
    this.availablePoint = availablePoint;
  }

  public static fromJSON = (value: any) => {
    const { starts_on, ends_on, obtained_point, available_point } = Object.assign({}, value);

    if ((starts_on !== null && typeof starts_on !== 'string') || new Date(starts_on).toString() === 'Invalid Date')
      throw new TypeError('.starts_on must be a string');
    if ((ends_on !== null && typeof ends_on !== 'string') || new Date(ends_on).toString() === 'Invalid Date')
      throw new TypeError('.ends_on must be a string');
    if (typeof obtained_point !== 'number') throw new TypeError('.obtained_point must be a number');
    if (typeof available_point !== 'number') throw new TypeError('.available_point must be a number');

    return new Budget({
      startsOn: starts_on ? new Date(starts_on) : undefined,
      endsOn: ends_on ? new Date(ends_on) : undefined,
      obtainedPoint: obtained_point,
      availablePoint: available_point,
    });
  };
}

export default Budget;
